"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheCalmSanctuary() {
  const headingReveal = useRevealOnScroll({
    threshold: 0.2
  });
  const textReveal = useRevealOnScroll({
    threshold: 0.2
  });
  const imageReveal = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223413" id="mastering-the-craft" className="bg-background text-foreground relative overflow-hidden min-h-screen flex items-center">
      <div className="mx-auto w-full max-w-[1600px] px-6 sm:px-8 lg:px-16 py-24 lg:py-0">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center">
          
          {}
          <div className="lg:col-span-7 flex flex-col gap-10 lg:pr-12 xl:pr-24 z-10">
            <h1 ref={headingReveal.ref as any} className={`font-serif text-5xl sm:text-6xl md:text-7xl lg:text-[3rem] xl:text-[4rem] leading-[1.1] tracking-tight text-foreground transition-all duration-[1200ms] ease-out uppercase ${headingReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              WE BRING EXPERT <br className="hidden sm:block" /> CRAFTSMANSHIP...
            </h1>
            
            <div ref={textReveal.ref as any} className={`flex flex-col gap-10 transition-all duration-[1200ms] delay-300 ease-out ${textReveal.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <p className="font-default font-normal text-base md:text-lg text-foreground/80 max-w-lg leading-relaxed">
                At AV Masonry, we don't just build, we bring visions to life, one brick at a time with precision and passion.
              </p>
              
              <div>
                <Link to="/HomePage">
                  <Button variant="outline" className="rounded-full border-primary bg-primary text-primary-foreground hover:bg-accent hover:text-accent-foreground transition-colors duration-500 font-default font-normal tracking-wide text-base px-10 py-7 h-auto">
                    Get a Quote
                  </Button>
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-5 h-[65vh] lg:h-[90vh] w-full relative overflow-hidden">
            <div ref={imageReveal.ref as any} className="w-full h-full relative overflow-hidden bg-muted/20">
              <img src="https://key-arachnid-1.10web.cloud/wp-content/uploads/2026/05/IMG_2955.HEIC-scaled.png" alt="AV Masonry stylized logo in a powerful black and white composition" className={`object-cover w-full h-full origin-center transition-transform duration-[3000ms] ease-out ${imageReveal.isVisible ? "scale-100" : "scale-110"}`} />
              {}
              <div className="absolute inset-0 bg-background/5 lg:hidden pointer-events-none"></div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}